import SSO_TEMPLATE_XML from "@modules/mgp/sso-template.xml";

const MGP_HOSTNAME = `${
  (process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.VERCEL_ENV) ===
  "production"
    ? "www"
    : "qa"
}.moneyguidepro.com`;

export const MGP_SSO_CERT_ISSUER =
  process.env.VERCEL_ENV === "production"
    ? "https://forme-client-sso-prod.com"
    : "https://forme-client-sso.com";
export const MGP_SSO_URL = `https://${MGP_HOSTNAME}/formefinancial/ssosamlnoref.aspx?IntegrationId=269`;
export const MGP_SAFARI_COOKIE_FIX_URL = `https://${MGP_HOSTNAME}/formefinancial/static/setthirdpartycookie`;
export const TEMPLATE_XML = SSO_TEMPLATE_XML;
export const PRIVATE_KEY_PEM = process.env.MGP_SSO_PRIVATE_KEY as string;
export const CERT_PEM = process.env.MGP_SSO_CERT as string;
